import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

export const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s200};
  &.--mobile {
    margin-left: ${cssTheme.layout.spacing.s500};
  }
`

export const DateAndRoomsText = styled(Text)`
  color: ${cssTheme.colors.content.neutral.secondary};
  margin-bottom: ${cssTheme.layout.spacing.s300};

  ${linariaMq.desktopMd} {
    margin-bottom: ${cssTheme.layout.spacing.s500};
  }
`

export const SeeAllText = styled.span`
  white-space: nowrap;
`

export const TopSectionText = styled.div`
  margin-bottom: ${cssTheme.layout.spacing.s300};
`
